import { useEffect } from 'react';

/**
 * Syncs the highlight overlay to the current target element whenever the target
 * or the highlight function changes (e.g. when the active step changes).
 */
export function useWalkthroughHighlightSync(
  targetElement: HTMLElement | null,
  highlightElement: (el: HTMLElement) => void,
): void {
  useEffect(() => {
    if (targetElement) {
      highlightElement(targetElement);
    }
  }, [targetElement, highlightElement]);
}
